import { PencilIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { DiscriminatedTaskUpdateUpdatedEvent } from '@/services/api/generated/matterChangesService';

import {
  ActivityActions,
  ActivityBody,
  ActivityDescription,
  ActivityDiffList,
  ActivityIcon,
  ActivityItem,
  ActivityLink,
} from '../activity-feed-v2';
import { getUserFromEvent } from '../activity-feed-v2/ActivityDiffList';
import { truncate } from '../activity-feed-v2/utils';

export interface TaskUpdateUpdatedEventProps {
  event: DiscriminatedTaskUpdateUpdatedEvent;
}

export const TaskUpdateUpdatedEvent: React.FC<TaskUpdateUpdatedEventProps> = ({
  event,
}) => {
  const { task_update, diff } = event.payload;
  const user = getUserFromEvent(event);

  const icon = (
    <ActivityIcon
      icon={
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-blue-100">
          <PencilIcon className="h-4 w-4 text-blue-600" />
        </div>
      }
    />
  );

  const body = (
    <ActivityBody>
      {task_update.update && (
        <ActivityDescription>
          <div className="text-sm text-gray-600 italic">
            &ldquo;{truncate(task_update.update, 150)}&rdquo;
          </div>
        </ActivityDescription>
      )}
      {diff && <ActivityDiffList diff={diff} defaultExpanded={false} />}
    </ActivityBody>
  );

  const actions = task_update?.task_id && (
    <ActivityActions>
      <ActivityLink
        href={`/matters/${event.matter_id}/updates?task_id=${task_update.task_id}`}
      >
        View Task
      </ActivityLink>
    </ActivityActions>
  );

  return (
    <ActivityItem
      icon={icon}
      title="Task Comment Updated"
      timestamp={new Date(event.occurred_at ?? new Date())}
      user={user}
      body={body}
      actions={actions}
    />
  );
};
